var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "zalogTileContent", staticClass: "zalog" },
    [
      _c("table-title", [_vm._v("Залоги")]),
      _vm._v(" "),
      _c(
        "update-button",
        {
          staticClass: "zalog__btn",
          attrs: {
            isLoading: _vm.isUpdating,
            success: Number(_vm.actual) === 1,
          },
          nativeOn: {
            click: function ($event) {
              return _vm.updateZalog.apply(null, arguments)
            },
          },
        },
        [
          !_vm.isUpdating
            ? _c("span", { attrs: { slot: "default" }, slot: "default" }, [
                _vm._v("Обновить информацию о залогах"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isUpdating
            ? _c("span", { attrs: { slot: "default" }, slot: "default" }, [
                _vm._v(
                  "Информация обновляется. Ожидайте или попробуйте обновить страницу позже"
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", { attrs: { slot: "success" }, slot: "success" }, [
            _vm._v("Информация о залогах актуальна."),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.auth
        ? _c(
            "div",
            { staticClass: "zalog__content" },
            [
              _vm.list.length === 0
                ? _c("span", { staticClass: "empty-message" }, [
                    _vm._v("Уведомления о залогах отсутствуют"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.list.length > 0
                ? _c("zalog-table", {
                    attrs: { list: _vm.renderList, actualDate: _vm.updateDate },
                  })
                : _vm._e(),
            ],
            1
          )
        : _c("demo-message"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }